// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M9.99935 17.0846C13.9114 17.0846 17.0827 13.9133 17.0827 10.0013C17.0827 7.64668 15.9338 5.5604 14.166 4.27246M10.8327 18.668L9.16602 17.0013L10.8327 15.3346M9.99935 2.91796C6.08733 2.91796 2.91602 6.08927 2.91602 10.0013C2.91602 12.3559 4.0649 14.4422 5.83268 15.7301M9.16602 4.66796L10.8327 3.00129L9.16602 1.33463"
    />
  </svg>
);
const IconChange = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconChange;
